// Textos de sistema — usar literalmente (docs/01-produto.md §8).
export const s = {
  appName: "Arena",
  tagline: "quiz ao vivo com respostas livres julgadas pelo Jev",

  codePrompt: "Digite o código da sala",
  nicknamePrompt: "Como quer ser chamado?",
  youreIn: "Você está dentro!",
  waitingHost: "Aguardando o anfitrião começar…",
  answerSent: "Resposta enviada",
  canEditUntil: "Você pode editar até o tempo acabar",
  judging: "O juiz está analisando…",
  verdictCorrect: "CERTO!",
  verdictPartial: "QUASE",
  verdictWrong: "ERROU",
  verdictManipulation: "O JUIZ PERCEBEU",
  manipulationNote: "Tentativa de convencer o juiz não vale ponto",
  reviewNeeded: "{n} respostas precisam da sua decisão",
  acceptSuggestions: "Aceitar sugestões",
  stageLobbyHint: "Entre em {host} com o código",
  playersCount: "{n} jogadores",
  reconnecting: "Reconectando…",
  roomLocked: "Sala trancada",
  roomFull: "Sala cheia",
  roomNotFound: "Sala não encontrada",
  kicked: "Você foi removido da sala",
  pickAnotherNick: "Escolha outro apelido",
  roomRestored: "Sala restaurada — toque em Retomar",
  judgeUnavailable: "Juiz automático indisponível — revisão manual",
  prepareYourself: "Prepare-se",
  thanksForPlaying: "Obrigado por jogar",
  manipulationBadge: "Tentou hackear o juiz",
  commonAnswers: "Respostas mais comuns",
  hiddenAnswer: "(resposta oculta)",
  correctCount: "{n} de {total} acertaram",

  // anfitrião
  createFirstQuiz: "Crie seu primeiro quiz",
  createInEditor: "Criar no editor",
  importJsonCsv: "Importar JSON/CSV",
  useExample: "Usar um exemplo",
  copyPromptForAI: "Copiar prompt para IA",
  newQuiz: "Novo quiz",
  import_: "Importar",
  myQuizzes: "Meus quizzes",
  login: "Entrar",
  createAccount: "Criar conta",
  imAHost: "Sou anfitrião",
  email: "E-mail",
  password: "Senha",
  name: "Nome",
  send: "Enviar",
  edit: "Editar",
  start: "Iniciar",
  endNow: "Encerrar agora",
  pause: "Pausar",
  resume: "Retomar",
  lock: "Trancar",
  unlock: "Destrancar",
  reveal: "Revelar",
  leaderboard: "Placar",
  next: "Próxima",
  podium: "Pódio",
  end: "Encerrar",
  openStage: "Abrir palco",
  copyStageLink: "Copiar link do palco",
  startRoom: "Iniciar sala",
  seeReport: "Ver relatório",
  playAgain: "Jogar de novo",
  exportCsv: "Exportar CSV",
  sessions: "Sessões",
  answeredOf: "{n}/{total} responderam",
  kick: "Expulsar",
  magicLinkSent: "Se o e-mail existir, enviamos um link de acesso.",
  forgotPassword: "Esqueci a senha",
  resetPassword: "Redefinir senha",
  loginWithMagicLink: "Entrar com link por e-mail",

  // editor de quiz
  questions: "Perguntas",
  addQuestion: "Adicionar pergunta",
  duplicateQuestion: "Duplicar",
  deleteQuestion: "Excluir",
  moveUp: "Mover para cima",
  moveDown: "Mover para baixo",
  saveQuiz: "Salvar",
  saved: "Salvo",
  saving: "Salvando…",
  exportJson: "Exportar JSON",
  exportCsv_: "Exportar CSV",
  startSession: "Iniciar sala",
  questionOf: "Pergunta {n} de {total}",
  estimatedTime: "≈{n} min de jogo",
  prompt: "Enunciado",
  mode: "Modo",
  timeLimit: "Tempo (s)",
  points: "Pontos",
  hintField: "Dica (exibida na revelação)",
  imageField: "Imagem da pergunta",
  uploadImage: "Enviar imagem",
  removeImage: "Remover",
  correctAnswer: "Resposta certa",
  acceptedAnswers: "Respostas aceitas",
  acceptedHelp: "Separe por vírgula: grafias, abreviações.",
  judgeNotesField: "Notas para o juiz",
  judgeNotesHelp: "O que aceitar/recusar em uma frase. Ex.: “Não aceitar ‘Rio’.”",
  options: "Opções",
  addOption: "Adicionar opção",
  markCorrect: "Marcar como certa",
  multiSelect: "Permite marcar várias",
  toleranceField: "Tolerância",
  toleranceHelp: "Número exato (0) ou percentual, ex.: 5%",
  closestWins: "Vence quem chegar mais perto",
  unitField: "Unidade (ex.: m, kg)",
  rubricLevels: "Níveis da rubrica",
  rubricWhat: "O que caracteriza este nível",
  rubricExamples: "Exemplos (separados por vírgula)",
  rubricPoints: "Pontos",
  addLevel: "Adicionar nível",
  previewPlayer: "Prévia do jogador",
  judgeHelpTitle: "Escrevendo bons gabaritos",
  judgeHelpBody:
    "Resposta curta e canônica (“Brasília”); aceitas com abreviações e grafias (“BSB”, “Brasilia”). " +
    "Notas para o juiz dizem o que aceitar/recusar em uma frase. Evite perguntas com várias " +
    "respostas certas em texto livre — prefira múltipla escolha. Números: use o modo número.",
  promptCopied: "Prompt copiado!",
  importTitle: "Importar quiz",
  importDrop: "Cole o conteúdo JSON ou CSV, ou escolha um arquivo",
  importButton: "Importar",
  importErrors: "{n} problema(s) encontrados",
  examples: "Exemplos",
  copy: "Copiar",
  playCount: "{n} jogos",
  questionCount: "{n} perguntas",
  settingsTitle: "Configurações da sala",
  speedScoring: "Pontos por velocidade",
  streakSetting: "Bônus de sequência",
  teamsSetting: "Times (0 = sem times)",
  allowEdit: "Permitir editar resposta",
  showCommon: "Mostrar respostas comuns",
  reviewPolicy: "Política de revisão",
  reviewWait: "Espera da revisão (s)",
  maxPlayers: "Máx. jogadores (0 = padrão)",
  validationFix: "Corrija os campos marcados antes de salvar.",
  answerRequired: "Resposta obrigatória",
  promptRequired: "Enunciado obrigatório",
  optionsRequired: "Mínimo 2 opções",
  correctRequired: "Marque ao menos uma opção certa",
  rubricRequired: "Rubrica precisa de 2–5 níveis e pontos por nível",

  // M2 — sala ao vivo (complementos)
  correct: "CERTO!",
  partial: "QUASE",
  wrong: "ERROU",
  review: "EM REVISÃO",
  manipulation: "O JUIZ PERCEBEU",
  manipulationSub: "Tentativa de convencer o juiz não vale ponto",
  youAreRank: "Você está em {rank}º",
  pointsEarned: "+{points}",
  yourAnswer: "Sua resposta",
  rightAnswer: "Gabarito",
  reviewTitle: "Revisão do anfitrião",
  nextQuestion: "Próxima pergunta",
  showLeaderboard: "Placar",
  showPodium: "Pódio",
  endSession: "Encerrar sessão",
  endAnswering: "Encerrar respostas",
  players: "Jogadores",
  banned: "Você foi banido da sala",
  stageLink: "Abrir palco",
  copyLink: "Copiar link",
  copied: "Copiado!",
  waitNext: "Aguarde a próxima pergunta…",
  lobby: "Saguão",
  trueLabel: "Verdadeiro",
  falseLabel: "Falso",
  typeAnswer: "Digite sua resposta",
  pickOptions: "Toque nas opções",
  typeNumber: "Digite um número",
  votePoll: "Vote",
  sessionEnded: "Sessão encerrada",
  finalScore: "{score} pontos",
  podiumYou: "Você ficou em {rank}º com {score} pontos",
  nicknameTaken: "Apelido já está em uso",
  nicknameOffensive: "Esse apelido não é permitido. Escolha outro.",
  enterRoom: "Entrar na sala",
  joinError: "Não foi possível entrar",
  startPlaying: "Criar sala e começar",
  sessionLive: "Sala ao vivo",
  stageQR: "Aponte a câmera para entrar",
  roomCode: "Código da sala",
  answers: "respostas",
  reviewItems: "{n} respostas precisam da sua decisão",
  suggestion: "Sugestão",
  hostControls: "Controles",
  autoAdvanceSetting: "Avançar automaticamente",

  // M4 — relatório, histórico, modo turma
  nicknameMode: "Modo de apelido",
  nicknameFree: "Livre",
  nicknameRoster: "Lista da turma",
  nicknamePrefix: "Prefixo",
  nicknamePrefixField: "Prefixo do apelido",
  rosterField: "Lista de nomes (um por linha)",
  rosterHelp: "Jogadores escolhem um nome da lista; nomes usados somem.",
  pickYourName: "Escolha seu nome",
  nicknameNotInRoster: "Nome fora da lista. Escolha um nome da turma.",
  rosterEmpty: "Todos os nomes da turma já foram usados.",
  mySessions: "Minhas sessões",
  noSessions: "Nenhuma sessão ainda.",
  reportTitle: "Relatório da sessão",
  playersCsv: "CSV de jogadores",
  answersCsv: "CSV de respostas",
  perQuestion: "Por pergunta",
  perPlayer: "Por jogador",
  accuracy: "Acerto",
  avgTime: "Tempo médio",
  reviewsCol: "Revisões",
  correctCountCol: "Acertos",
  maxStreakCol: "Maior sequência",
  answersList: "Respostas",
  correctedBadge: "Corrigida",
  fixVerdict: "Corrigir veredito",
  verdictSaved: "Veredito atualizado — placar recalculado.",
  backToSessions: "Voltar às sessões",

  // M5 — times, reações, closestWins, dica
  team: "Time {n}",
  yourTeam: "Seu time",
  pickTeam: "Escolha seu time",
  teamAuto: "Automático",
  teamStandings: "Placar de times",
  teamChampion: "Time campeão",
  closestTitle: "Mais próximos",
  hintLabel: "Dica",

  // ---- Admin (M6) ----
  adminTitle: "Operação",
  adminRooms: "Salas ativas",
  adminEndRoom: "Encerrar",
  adminEndConfirm: "Encerrar a sala {code} agora? Os jogadores serão desconectados.",
  adminNoRooms: "Nenhuma sala ativa no momento.",
  adminJev: "Saúde do Jev",
  adminOverview: "Visão geral",
  adminAudit: "Auditoria",
  adminMetrics: "Métricas",
  adminBreakerOpen: "breaker aberto",
  adminBreakerClosed: "breaker fechado",
  adminUptime: "tempo de ar",
  adminGoroutines: "goroutines",
  adminForbidden: "Esta área é restrita a operadores.",
} as const;

export type StringKey = keyof typeof s;

// fmt substitui {n}, {total}, {host} etc.
export function fmt(tpl: string, vars: Record<string, string | number>): string {
  return tpl.replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? `{${k}}`));
}
